import { render, staticRenderFns } from "./orders_new_cart_modal.vue?vue&type=template&id=579704d0&"
import script from "./orders_new_cart_modal.vue?vue&type=script&lang=js&"
export * from "./orders_new_cart_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports